import React from "react";
import { FileSearch } from "lucide-react";

export function SearchEmptyState() {
  return (
    <div className="flex w-full flex-col items-center gap-4 rounded-xl border border-[#E4E7EC] bg-white p-6 text-center">
      <FileSearch className="h-12 w-12 text-[#D3D5DB]" />
      <h3 className="text-lg font-semibold text-[#101827]">
        Search for a borrower
      </h3>
      <p className="text-sm text-[#697083]">
        Edit conditions from DigiFi, preview the letter in real time, and send —
        without switching systems.
      </p>
    </div>
  );
}
